import React,{useRef, useState, useEffect} from "react";
import Select from "react-select";
import CreatableSelect from 'react-select/creatable';
import {List, SquaresFour, MapTrifold } from "@phosphor-icons/react";
import vindrApi from "../utils/vindrapi";
import authApi from "../utils/authApi";
import { Col, Row, Form, Nav} from "react-bootstrap";


export default function TagColor(props) {
	

	const [loaded,setLoaded]			= useState(false); //status variable set when all data is loaded
	const [errors,setErrors]			= useState(new Set()); //what layer to show, default show owners
	const [selected,setSelected]		= useState(props.value ? props.value : {}); //what layer to show, default show owners
	const [colors,setColors]			= useState([]); //what layer to show, default show owners

	useEffect(()=>{
		getData();
	},[])
	
	

	const getData = ()=>{ 
		

		
		Promise.all([vindrApi.getToken()])
		.then((res) => {
			return Promise.all([authApi.getUser()]);
		})
		.then((res) => {
	
			const dataRequests = [
				vindrApi.getTagColors()
			];
			return Promise.all(dataRequests);
		})
		.then((res)=>{
			
			setColors(res[0])
			
			
		}).catch((e)=>{
			console.log(e);
			
			setLoaded(true);
			setErrors(p => [...p, 'Error fetching data']); //add this error to previous errors
		});
		return;

	};	
	
	const setColor = (color) => {
		
		setSelected(color);
		
		if(props.onChange)
			props.onChange(color);
	}
	
	return (
		<div className="tag-color-selector">

				{
				colors.map((c, idx)=>{ return <span key={idx} className={"color-option " + (selected == c.color ? 'active' : '')} onClick={()=>{setColor(c.color)}} style={{backgroundColor:c.color}}></span> })
				}

		</div>
	)
}